import {useMutation} from "@apollo/client";

import {DropdownActionItem} from "@/components/quickActionsBar/DropdownAction.tsx";
import {GQL_GLOBAL_ALERT_STATE_TOGGLE_IGNORE, GQL_GLOBAL_ALERT_STATES} from "@/lib/queries/alerting.ts";
import {GQL_DASHBOARD_STATS} from "@/lib/queries/website.ts";
import {GlobalAlertState} from "@/lib/types/alerting.ts";
import {GraphQLResponse} from "@/lib/types/common.ts";

export const AlertToggleIgnore = ({gas}: {gas: GlobalAlertState}) => {
  const [toggleIgnore] = useMutation<GraphQLResponse<null>>(GQL_GLOBAL_ALERT_STATE_TOGGLE_IGNORE, {
    refetchQueries: [GQL_GLOBAL_ALERT_STATES, GQL_DASHBOARD_STATS],
  });

  return (
    <DropdownActionItem
      text={!gas.ignored ? "Ignore Alert" : "Don't ignore Alert"}
      onClick={() => toggleIgnore({variables: {id: gas.id}})}
    />
  );
};
